import { render, staticRenderFns } from "./courseChart.vue?vue&type=template&id=8bf0bfc2&scoped=true"
import script from "./courseChart.vue?vue&type=script&lang=js"
export * from "./courseChart.vue?vue&type=script&lang=js"
import style0 from "./courseChart.vue?vue&type=style&index=0&id=8bf0bfc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0bfc2",
  null
  
)

export default component.exports